
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import PokemonModule from "@/store/Pokemon";
import ChooseFavorite from "./ChooseFavorite.vue";
@Component({
  components: {
    ChooseFavorite,
  },
})
export default class EachPokemon extends Vue {
  @Prop({ required: true }) item!: {
    id: number;
    name: string;
    sprites: { other: { dream_world: { front_default: string } } };
  };
  liste = [];
  isActive = false;

  addToFavorites() {
    // this.isActive = true;
    PokemonModule.SET_TITLE(this.item);
    // this.$store.dispatch("addFavorites", this.item);
    let local = JSON.parse(localStorage.getItem("liste") as string);
    if (local && local.some((res) => res.id === this.item.id)) {
      null;
    } else {
      local.push(this.item);
    }
    localStorage.setItem("liste", JSON.stringify(local));
  }
  chooseFavorite(id: number) {
    console.log(this.isActive);
    this.isActive = !this.isActive;
    console.log(this.isActive);
    console.log(id, event);

    // this.isActive = !this.isActive;
  }
  closeFavorite() {
    console.log(event);
    this.isActive = false;
  }
}
